import React from 'react';
import View from './View';

const Edit = (props) => (
  <div className="public-ui">
    <View {...props} />
  </div>
);
export default Edit;
